import script from "./RepaymentTypeButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./RepaymentTypeButton.vue?vue&type=script&setup=true&lang=ts"

import "@/styles/professional-grad/repayment-type-button.css?vue&type=style&index=0&id=0dc77dbf&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dc77dbf"]])

export default __exports__